import { motion } from "framer-motion";

const steps = [
  { no: "01", title: "Share requirement", body: "Tell us the amount, purpose and timeline — online, over a call or on WhatsApp." },
  { no: "02", title: "Initial assessment", body: "We evaluate your profile and tell you honestly what is achievable and at what cost." },
  { no: "03", title: "Lender matching", body: "Your file goes only to the lenders most likely to approve it — no scattergun applications." },
  { no: "04", title: "Documentation", body: "We prepare and submit a complete file so you avoid the back-and-forth." },
  { no: "05", title: "Sanction & disbursal", body: "We negotiate terms through sanction and stay with you till the money lands." },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-14 lg:py-20 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="max-w-2xl mb-14"
      >
        <p className="overline-label mb-4">The journey</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight">How it works.</h2>
        <p className="mt-5 text-[#A0AAB2] text-base md:text-lg leading-relaxed">
          Five steps from first conversation to money in your account — with one advisor owning the file throughout.
        </p>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {steps.map((s, i) => (
          <motion.div
            key={s.no}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`journey-step-${s.no}`}
            className="relative bg-slate2 border border-white/10 p-6"
          >
            <span className="font-serif text-4xl text-gold/40">{s.no}</span>
            <h3 className="font-serif text-xl mt-4 mb-2">{s.title}</h3>
            <p className="text-xs text-[#A0AAB2] leading-relaxed">{s.body}</p>
            {i < steps.length - 1 && (
              <span className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gold/30" aria-hidden="true" />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
